import { Grid, Typography, Stack } from 'components/ui';
import { GrayCard } from 'components/styles_components/card';
import { CardOptionTypography } from 'components/styles_components/typography';
import Date from 'components/date';

const DateCard = ({ title, date, emptyComponent = '-' }) => (
  <Grid size={{ xs: 6, lg: 3 }}>
    <GrayCard>
      <Stack>
        <CardOptionTypography>{title}</CardOptionTypography>
        <Typography component="span">
          <Date date={date} emptyComponent={emptyComponent} />
        </Typography>
      </Stack>
    </GrayCard>
  </Grid>
);

export default DateCard;
